import React from "react";
import styles from "./dropdown.module.css";
import searchIconGrey from "../../public/assets/search-icon.svg";

const DropdownMenu = ({
  isFromStudentModal,
  options,
  countryOption,
  styling,
  handleSelectOption,
  searchText,
  setSearchText,
  search,
}) => {
  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  return (
    <ul
      className={
        isFromStudentModal
          ? styles.dropdownList + " " + styles.studentDropdownList
          : styles.dropdownList
      }
      style={styling === "quotepage" ? { paddingLeft: "12px" } : {}}
    >
      {styling === "homepage" || styling === "quotepage" ? (
        countryOption.map((option, index) => (
          <li key={index} onClick={() => handleSelectOption(option)}>
            {option && (
              <div className={styles.inputleftdiv}>
                {option.image !== "" && (
                  <img
                    src={option.image}
                    alt=""
                    className={styles.imagedivOption}
                  />
                )}
                <div className={styles.currencyOption}>{option.label}</div>
              </div>
            )}
          </li>
        ))
      ) : styling === "transactionPage" ? (
        countryOption.map((option, index) => (
          <li key={index} onClick={() => handleSelectOption(option)}>
            {option && (
              <div className={styles.inputleftdiv}>
                {option.image !== "" && (
                  <img
                    src={option.image}
                    alt=""
                    className={styles.imagedivOption}
                  />
                )}
                <div className={styles.currencyOption}>{option.value}</div>
              </div>
            )}
          </li>
        ))
      ) : (
        <>
          {search && (
            <li>
              <span className={styles.searchIcon}>
                <img src={searchIconGrey} alt="search-icon"></img>
              </span>
              <input
                type="text"
                placeholder="Search..."
                value={searchText}
                onChange={(e) => handleSearchChange(e)}
                className={styles.searchInput}
              />
            </li>
          )}
          {options.map((option, index) => (
            <>
              <li key={index} onClick={() => handleSelectOption(option)}>
                {option.label}
              </li>
            </>
          ))}
        </>
      )}
    </ul>
  );
};

export default DropdownMenu;
